export default "__VITE_ASSET__c70851b9__"